import { Grid, makeStyles, Typography } from "@material-ui/core";
import { COLORS } from "../../../theme/colors";

const useStyles = makeStyles(() => ({
  low: {
    backgroundColor: COLORS.purples[20],
  },
  normal: {
    backgroundColor: COLORS.purples[50],
  },

  high: {
    backgroundColor: COLORS.purple,
  },
  highText: {
    color: COLORS.white,
  },
}));

export const ColorCircleIndicator = ({ type, text }) => {
  const classes = useStyles();

  return (
    <Grid
      container
      className={
        !!text
          ? null
          : type === "L"
          ? classes.low
          : type === "H"
          ? classes.high
          : classes.normal
      }
      style={{
        width: 21,
        height: 21,
        borderRadius: "50%",
        marginBottom: 6,
      }}
      justifyContent="center"
      alignItems="center"
    >
      {type === "H" && (
        <Typography className={classes.highText} variant="body2">
          H
        </Typography>
      )}
      {text && <Typography variant="body2">{text}</Typography>}
    </Grid>
  );
};
